import { render, staticRenderFns } from "./addVehicleDetails.vue?vue&type=template&id=9922fca0"
import script from "./addVehicleDetails.vue?vue&type=script&lang=js"
export * from "./addVehicleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports